export {};

declare global {
    interface Window {
        privacyManager?: PrivacyManager;
    }
}

class PrivacyManager {

    private readonly container: HTMLElement | null;

    /**
     * Constructs a new instance of the Privacy Manager.
     */
    constructor(selector: string) {
        this.container = document.querySelector(selector);

        if (!this.container) return;

        this.listenForInteraction();
    }

    private listenForInteraction() {
        this.container?.addEventListener('change', () => {
            const buttons = this.container?.querySelectorAll('[data-privacy-choice]') as NodeListOf<HTMLButtonElement>;

            if (!buttons)
                throw Error('The privacy option buttons can\'t be found in the privacy manager container.');

            for (const button of buttons) {
                const privacyOption = button.dataset.privacyChoice;

                button.dataset.display = (privacyOption === 'customized') ? '' : 'hidden';
            }
        });
    }

    public setPrivacyChoices(data: object) {
        if (!this.container || typeof gtag === "undefined") return;

        gtag('consent', 'update', data);

        this.container.dataset.privacyManager = 'hidden';
    }
}

// Initialize the privacy manager
window.privacyManager = new PrivacyManager('[data-privacy-manager]');